import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { API_DATE_FORMAT, JSON_HEADER } from "@constants";
import { ITransaction } from "../interface/ITransactionHistory";
import { format, subMonths } from "date-fns";
import { getTransactionHistoryListApiRoute } from "@api-routes/accountReceivableFacade";
import { getResponseToState, IPageableTransactionsHistoryResponse } from "../mappers/getTransactionHistoryListMapper";
import { useFetch } from "@common/hook/useFetch";
import { IError } from "itsf-ui-common";

interface IParams {
    month: number;
    currentPage: number;
    accountId: string;
}

export const useTransactionHistoryList = (props: IParams) => {
    const { currentPage, month, accountId } = props;
    const [getTransactionHistoryState, { get }] = useFetch();
    const [transactionHistoryList, setTransactionHistoryList] = useState<ITransaction[]>([]);
    const [totalPages, setTotalPages] = useState(0);
    const [error, setError] = useState<IError>();
    const { t } = useTranslation("payment");

    const getTransactionHistory = () => {
        const now = new Date();
        const to = format(now, API_DATE_FORMAT);
        const from = format(subMonths(now, month), API_DATE_FORMAT);
        const params = `?from=${from}&to=${to}&page=${currentPage}`;

        get<IPageableTransactionsHistoryResponse>(getTransactionHistoryListApiRoute(accountId, params), {
            forwardError: true,
            headers: JSON_HEADER,
        })
            .then((transactionHistoryListResponse) => {
                if (transactionHistoryListResponse) {
                    const transactionHistoryListMapped = getResponseToState(transactionHistoryListResponse);

                    setTransactionHistoryList(transactionHistoryListMapped.content);
                    setTotalPages(transactionHistoryListMapped.totalPages);
                }
            })
            .catch(() => setError({ errorMessage: t("noTransaction") }));
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(getTransactionHistory, [month, currentPage, accountId]);

    return { getTransactionHistoryState, transactionHistoryList, error, getTransactionHistory, totalPages };
};
